module.exports = __webpack_public_path__ + "static/media/Microsoft_Azure_Logo.a18d7684.png";